<template>
  <div class="app-home-menu fs">
    <template v-if="CMenuComponent">
      <CMenuComponent :collapse="collapse" />
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, useCurrentAppInstance, DEFAULT_PAGE_NAME } from '@zto/zpage'

const props = defineProps<{
  collapse?: boolean
}>()

const app = useCurrentAppInstance()
const homeMenuConfig = app.useAppConfig('menu.homeMenu', {})

const CMenuComponent = app.resolveComponent(homeMenuConfig?.component || 'CAppHomeMenu')
</script>

<style lang="scss" scoped></style>
